import { CalendarDays, Clock } from "lucide-react";
import { prettyTime } from "@/lib/format";

const toISO = (d) => d.toISOString().slice(0, 10);

export default function BookingCalendar({ dates, selectedDate, onSelectDate, slots, loadingSlots, selectedTime, onSelectTime }) {
  return (
    <div className="lg:col-span-7">
      <div className="mb-10">
        <p className="mb-5 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-pine/60">
          <CalendarDays size={14} className="text-terra" /> 1 — Choose a day
        </p>
        <div className="flex gap-2 overflow-x-auto pb-2" data-testid="booking-date-list">
          {dates.map((d) => {
            const iso = toISO(d);
            const active = iso === selectedDate;
            return (
              <button
                key={iso}
                onClick={() => onSelectDate(iso)}
                data-testid={`booking-date-${iso}`}
                className={`flex min-w-[86px] flex-col items-center border px-4 py-4 transition-colors duration-300 ${
                  active ? "border-forest bg-forest text-bone" : "border-linen bg-white/60 text-pine/70 hover:border-forest/40"
                }`}
              >
                <span className="font-mono text-[10px] uppercase tracking-[0.2em]">
                  {d.toLocaleDateString("en-US", { weekday: "short" })}
                </span>
                <span className="mt-1 font-serif text-2xl font-semibold">{d.getDate()}</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em]">
                  {d.toLocaleDateString("en-US", { month: "short" })}
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <p className="mb-5 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-pine/60">
          <Clock size={14} className="text-terra" /> 2 — Choose a time (Pacific)
        </p>
        {loadingSlots ? (
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-pine/40" data-testid="booking-slots-loading">
            Loading slots…
          </p>
        ) : (
          <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-6" data-testid="booking-slot-grid">
            {slots.map((s) => (
              <button
                key={s.time}
                disabled={!s.available}
                onClick={() => onSelectTime(s.time)}
                data-testid={`booking-slot-${s.time}`}
                className={`border px-2 py-3 font-mono text-xs tracking-[0.1em] transition-colors duration-300 ${
                  selectedTime === s.time
                    ? "border-forest bg-forest text-bone"
                    : s.available
                    ? "border-linen bg-white/60 text-pine/70 hover:border-forest/40 hover:text-forest"
                    : "cursor-not-allowed border-linen/60 bg-linen/40 text-pine/25 line-through"
                }`}
              >
                {prettyTime(s.time)}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
